import { getFeatureFlag } from './settings-api'

// Use this config property until zone management api is available in production.
export const getZoneManagementEnabledStatus = () => getFeatureFlag('zone-management')
